import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitBatchNumberServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitBatchNumberServices";

const AddNewStudyKitBatchNumberMetadata = ({ getEIWRSKitBatchNumberMetadataData }) => {
  let { studyId } = useParams();
  const [kitBatchNumber, setKitBatchNumber] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewEIWRSKitBatchNumberMetadata = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.batchNumber = kitBatchNumber;
    let data = await eiwrsKitBatchNumberServices.addNewEIWRSKitBatchNumberMetadata(
      userData
    );
    if (data?.statusCode === 200) {
      setKitBatchNumber("");
      getEIWRSKitBatchNumberMetadataData()
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    setKitBatchNumber("");
  }, []);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Batch Number{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setKitBatchNumber(e.target.value)}
          value={kitBatchNumber}
          className="br3"
          placeholder="Enter Batch Number"
          batchNumber="text"
        />
      </Form.Group>
      <div className="text-end">
        <button
          disabled={!kitBatchNumber || buttonLoader}
          onClick={addNewEIWRSKitBatchNumberMetadata}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm"/> Adding...
            </div>
          ) : (
            "Add Batch Number"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddNewStudyKitBatchNumberMetadata;
